/* eslint-disable react/prop-types */
import React from "react";
import { Box, MultiSelect } from "@mantine/core";
import { COLORS } from "../../../constants/colors";
import { useQuery } from "@tanstack/react-query";
import { getSelectOptionsByTableName } from "../../../services/common.service";

const normalize = (str) => str?.toString().trim().toLowerCase();

const MultiSelectWithAPI = ({
  placeholder,
  label,
  value,
  itemData,
  setValue,
  isRequired,
  tableName,
  ...props
}) => {
  const [search, setSearch] = React.useState({
    enabled: true,
    text: "",
  });
  const dataQuery = useQuery({
    enabled: search?.enabled,
    queryKey: [
      `data-select`,
      tableName,
      search?.text,
      itemData?.id,
      JSON.stringify(itemData?.filters),
    ],
    queryFn: () =>
      getSelectOptionsByTableName({
        tableName,
        filters: itemData?.filters
        ? JSON.stringify(itemData.filters) 
        : `{"is_active_eq":true}`,
        search: search?.text,
      }),
    select: (data) =>
      data
        ?.map((items) => {
          const displayKeys = JSON.parse(itemData?.display_options || "[]");
          const label = displayKeys
            .map((key) => items?.[key])
            .filter(Boolean)
            .join(" - ")
            .toUpperCase();

          const rawValue = items?.[itemData?.return_value || "id"];

          return {
            label: label || "NA",
            value: String(rawValue),
            rawValue,
          };
        })
        .filter((item) => item.value !== "undefined"),
  });

  const handleChange = (selectedValues) => {
    const mappedValues = selectedValues.map((v) => {
      const found = dataQuery.data?.find((item) => item.value === v);
      return found?.rawValue;
    });

    // console.log("mappedValues" , mappedValues)

    setValue(mappedValues.filter(Boolean));
  };

  React.useEffect(() => {
    if (!dataQuery.data || !value?.length) return;

    const hasIds = value.some((v) => !isNaN(Number(v)));
    if (hasIds) return;

    const mappedIds = value
      .map((v) => {
        const found = dataQuery.data.find((item) =>
          normalize(item.label).includes(normalize(v))
        );
        return found?.rawValue;
      })
      .filter(Boolean);

    if (mappedIds.length) {
      setValue(mappedIds);
    }
  }, [dataQuery.data, value, setValue]);

  return (
    <Box>
      <MultiSelect
        data={dataQuery.data ?? []}
        value={value?.map(String)}
        placeholder={placeholder}
        onChange={handleChange}
        withAsterisk={isRequired}
        searchable
        clearable
        // onSearchChange={e => {
        //     setSearch({
        //         enabled: true,
        //         text: e
        //     })
        // }}
        label={label}
        onSearchChange={(e) => setSearch({ enabled: true, text: e })}
        {...props}
      />
    </Box>
  );
};

export default MultiSelectWithAPI;
